import IncomeStructure from './IncomeStructure';

export default IncomeStructure;
